import { createGetChannel,createPostChannel, createGetDownloadChannel } from "@src/utils/apis/requestRX";
import { Fetch, ResponseData } from "@src/utils/apis/typeRX";

//根据路径获取文件
//参数
export interface FileDownloadByPathParams {
    filePath: string;
}
export const fileDownloadByPath: Fetch<FileDownloadByPathParams, ResponseData<string>> = createGetDownloadChannel("/api/reexuan-blockchain-service/chain/fileDownload/byPath");